import { render, staticRenderFns } from "./chargeDialog.vue?vue&type=template&id=bbda2176&scoped=true&"
import script from "./chargeDialog.vue?vue&type=script&lang=js&"
export * from "./chargeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbda2176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbda2176')) {
      api.createRecord('bbda2176', component.options)
    } else {
      api.reload('bbda2176', component.options)
    }
    module.hot.accept("./chargeDialog.vue?vue&type=template&id=bbda2176&scoped=true&", function () {
      api.rerender('bbda2176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/Wrokflow/chargeDialog.vue"
export default component.exports